import { render, staticRenderFns } from "./workbenchApproval.vue?vue&type=template&id=33a4f6ce&scoped=true"
import script from "./workbenchApproval.vue?vue&type=script&lang=js"
export * from "./workbenchApproval.vue?vue&type=script&lang=js"
import style0 from "./workbenchApproval.vue?vue&type=style&index=0&id=33a4f6ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a4f6ce",
  null
  
)

export default component.exports